import { API_BASE_URL } from "../settings/appConfig.js";

const commonHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

async function checkNetworkStatus() {
  if (!navigator.onLine) {
    throw new Error(
      "No internet connection. Please check your network settings."
    );
  }
}

async function checkAPIEndPoint(endpoint) {
  const url = `${API_BASE_URL}/employee/user/getall`;
  try {
    await fetch(url, { method: "GET" });
  } catch (error) {
    console.log(error);
    throw new Error(
      "Internal network error please contact system administrator"
    );
  }
}
async function handleResponse(response) {
  if (!response.ok) {
    let errorMessage;
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || "Unknown error occurred";
    } catch (jsonError) {
      errorMessage = "An error occurred while processing the request.";
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

async function fetchData(endpoint, token) {
  await checkNetworkStatus();
  await checkAPIEndPoint(endpoint);
  try {
    const headers = {
      ...commonHeaders,
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, { headers });
    return handleResponse(response);
  } catch (error) {
    throw error;
  }
}

async function postData(endpoint, requestData, token) {
  await checkNetworkStatus();
  await checkAPIEndPoint(endpoint);
  try {
    const headers = {
      ...commonHeaders,
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      headers,
      method: "POST",
      body: JSON.stringify(requestData),
    });
    return handleResponse(response);
  } catch (error) {
    throw error;
  }
}
async function putData(endpoint, requestData, token) {
  await checkNetworkStatus();
  await checkAPIEndPoint(endpoint);
  try {
    const headers = {
      ...commonHeaders,
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      headers,
      method: "PUT",
      body: JSON.stringify(requestData),
    });
    return handleResponse(response);
  } catch (error) {
    throw error;
  }
}

async function deleteData(endpoint, token) {
  await checkNetworkStatus();
  await checkAPIEndPoint(endpoint);
  try {
    const headers = {
      ...commonHeaders,
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      headers,
      method: "DELETE",
    });
    return handleResponse(response);
  } catch (error) {
    throw error;
  }
}

export { fetchData, postData, putData, deleteData };
